// extracted by mini-css-extract-plugin
export default {"mCard":"fF-z","image":"gF-z","imageNoBackground":"hF-z","imageHasCategory":"iF-z","fullWidth":"jF-z"};